import Layout from "../../components/layout";
import { GetStaticProps } from "next";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function KubeconNa2026({ props }) {
    const { t } = useTranslation('common');
    return (
        <>
            <Layout isHomePage={false} pageTitle={"Meet Middleware at KubeCon + CloudNativeCon India 2026 | Booth S17"}
                ogImage={"/images/events/kubecon-india-2026.webp"}
                uri={"/events/kubecon-india-2026/"}
                metaTitle={"Meet Middleware at KubeCon + CloudNativeCon India 2026 | Booth S17"}
                metaDesc={"Join Middleware at KubeCon + CloudNativeCon India 2026 in Mumbai. Visit Booth S17 to explore Kubernetes monitoring, OpenTelemetry observability, distributed tracing, and AI-powered incident management with OpsAI."}
                metaRobotsNoindex={"index"}
                metaRobotsNofollow={"follow"}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={"/events/"} className={"back-to-blog"}>Back to Event List</Link>
                                        <div className={'d-flex aws-mw'}>

                                        </div>
                                        <div className={'inner-hero'}>
                                            <h1>Meet <span>Middleware</span> at <span>KubeCon</span> + <span>CloudNativeCon</span> India 2026 </h1>
                                            <p><b>Date: </b>June 18-19th 2026</p>
                                            <p><b>Venue: </b> Jio World Convention Centre, Mumbai, India. Booth S17</p>
                                        </div>
                                    </div>
                                    <div className={'right-block closed'}>
                                        <img
                                            src={'/images/events/kubecon-india-2026.webp'} alt={'Join Middleware at KubeCon India 2026!'} width={"100%"} height={"100%"} />
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block sm-width'}>
                                    <p>Middleware is excited to announce our participation in KubeCon + CloudNativeCon India 2026, one of the largest gatherings of Kubernetes, cloud-native, DevOps, and platform engineering professionals in the region.</p>

                                    <p>Join us at Booth S17 to explore how modern engineering teams are using OpenTelemetry-native observability, AI-powered operations, and Kubernetes monitoring to build more reliable cloud-native applications.</p>

                                    <h4>Meet the Middleware Team</h4>
                                    <p>Our engineers, product experts, and observability specialists will be available throughout the event to answer questions, discuss observability challenges, and share practical insights from real-world cloud-native environments.</p>
                                    <p>Whether you're evaluating observability platforms, adopting OpenTelemetry, or looking to improve Kubernetes reliability, we'd love to connect.</p>
                                    <img src={"/images/events/middleware-sales-team.webp"} alt={"Middleware Team"}
                                        width={100} height={100} />

                                    <ul>
                                        <li><Link href={"https://www.linkedin.com/in/sawaramsuthar/"}
                                            target={"_blank"}>Sam Suthar</Link>, Founding Director, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/vivektilva/"} target={"_blank"}>Vivek
                                            Tilva</Link>, Product Manager, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/malay-tanna/"}
                                            target={"_blank"}>Malay Tanna</Link>, GTM Lead, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/archish-thakkar/"}
                                            target={"_blank"}>Archish Thakkar </Link>, Principal Engineer, Middleware</li>
                                        <li><Link href={"https://www.linkedin.com/in/meeral-pithwa-/"}
                                            target={"_blank"}>Meeral Pithwa</Link>, Technical Solutions Engineer, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/naman-jain-3a3892284/"}
                                            target={"_blank"}>Naman Jain</Link>, Senior Software Engineer, Middleware
                                        </li>
                                    </ul>

                                    <h4>What’s Middleware All About?</h4>
                                    <p>Middleware is a full-stack observability platform that detects issues across infrastructure, APM, and real user monitoring and resolves them automatically using the AI SRE Agent. From root cause to fix, Middleware closes the loop so your team spends less time firefighting and more time building.</p>

                                    <h4>What does that mean for your business?</h4>
                                    <p>Upto 10X reduction in observability costs</p>
                                    <p>Upto 75% improvement in operational efficiency</p>
                                    <p>Upto 20% faster time to resolution (MTTR)</p>
                                    <p>Upto 25% improved developer productivity</p>

                                    <h4>Middleware’s Observability Suite Includes: </h4>

                                    <ul>
                                        <li><b>Infrastructure Monitoring:</b> Monitor and optimize infrastructure in
                                            real-time for peak efficiency.
                                        </li>
                                        <li><b>Log Monitoring:</b> Unify log data across your tech stack to quickly
                                            identify and fix issues.
                                        </li>
                                        <li><b>APM:</b> Track app performance, identify bottlenecks and fix issues in
                                            real time.
                                        </li>
                                        <li><b>LLM Observability:</b> Monitor, troubleshoot, and optimize LLM
                                            applications in real time.
                                        </li>
                                        <li><b>AI-Powered Dashboards:</b> Leverage intelligent dashboards with automated insights, anomaly detection, and real-time performance analytics.
                                        </li>
                                        <li><b>Database Monitoring:</b> Visualize and track database metrics in real
                                            time for optimal performance.
                                        </li>
                                        <li><b>Synthetic Monitoring:</b> Simulate your app to spot and fix issues before
                                            they affect customers.
                                        </li>
                                        <li><b>Serverless Monitoring:</b> Get full visibility and control over
                                            serverless apps for optimal performance.
                                        </li>
                                        <li><b>Container Monitoring:</b> Get real-time visibility into containerized
                                            apps with data and analytics.
                                        </li>
                                        <li><b>Real User Monitoring:</b> Analyze user journeys on the web and mobile to
                                            optimize performance and experience.
                                        </li>
                                    </ul>

                                    <h4>See OpsAI in Action</h4>
                                    <p>Get a live demonstration of <Link href={"/product/ops-ai/"}>OpsAI</Link>, Middleware's AI SRE Agent, designed to help engineering teams:</p>
                                    <ul>
                                        <li>Detect incidents faster</li>
                                        <li>Perform automated root cause analysis</li>
                                        <li>Correlate logs, metrics, traces, and RUM data</li>
                                        <li>Troubleshoot Kubernetes issues</li>
                                        <li>Accelerate incident resolution</li>
                                    </ul>
                                    <p>Learn how teams are leveraging AI-driven observability to spend less time firefighting and more time building.</p>

                                    <h4>Schedule a Meeting</h4>
                                    <p>Planning to attend KubeCon + CloudNativeCon India 2026?</p>
                                    <p>Stop by <b>Booth S17</b> or schedule time with our team in advance to discuss your observability goals, infrastructure challenges, and AI-powered operations initiatives.</p>
                                    <p>Curious how Middleware can work for your team? <Link href={"/demo-request/"}>Request a demo</Link> and see it in action.</p>

                                    <h4>See You in Mumbai!</h4>
                                    <p>We're looking forward to meeting developers, SREs, platform engineers, DevOps professionals, and cloud-native enthusiasts from across the community.</p>

                                    <p>Visit Middleware at <b>Booth S17</b> and discover how unified observability and AI-powered operations can help your team build and operate with confidence.</p>

                                    <p><b>See you at KubeCon + CloudNativeCon India 2026! 🚀</b></p>

                                    <h4>Exclusive Gift Hamper!</h4>
                                    <img src={"/images/events/middleware-swag.jpg"} alt={"Middleware Swag"} width={100} height={100} />
                                    <p>Meet the Middleware team and grab an exclusive gift hamper packed with Middleware goodies, stickers, notebooks, tees, and more.</p>
                                </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    const translations = await serverSideTranslations(
        ctx?.locale ?? "en",
        ["common", "header", "footer"],
        nextI18NextConfig,
    );
    return {


        props: {
            ...translations,
            pageTitle: "Meet Middleware at KubeCon + CloudNativeCon India 2026 | Booth S17",
            description: "Join Middleware at KubeCon + CloudNativeCon India 2026 in Mumbai. Visit Booth S17 to explore Kubernetes monitoring, OpenTelemetry observability, distributed tracing, and AI-powered incident management with OpsAI.",
            ogImage: "/images/events/kubecon-india-2026.webp",
            uri: "/events/kubecon-india-2026/",
            metaTitle: "Meet Middleware at KubeCon + CloudNativeCon India 2026 | Booth S17",
            metaDesc: "Join Middleware at KubeCon + CloudNativeCon India 2026 in Mumbai. Visit Booth S17 to explore Kubernetes monitoring, OpenTelemetry observability, distributed tracing, and AI-powered incident management with OpsAI.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
        // revalidate: 10,
    }
}